import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { dummySidebar } from "utils/dummyData/DummySidebar";
import {
  MenuConfigModel,
  SidebarMenuConfigModel,
} from "./model/SidebarMenuConfigModel";
import { isEmpty } from "lodash";
import { dummySidebarSupport } from "utils/dummyData/DummySidebarSupport";

export interface IConfigRepository {
  getSidebarMenu(
    role: boolean
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>>;
}

export interface IMenuService {
  name: string;
  path: string;
  componentName: string;
  icon: string;
  subMenu?: IMenuService[] | [];
  enable?: boolean;
}

export class SidebarMenuConfigRepository implements IConfigRepository {
  async getSidebarMenu(
    role: boolean,
    language?: string,
    note?: string
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>> {
    let menuConfig: MenuConfigModel[] = [];
    let rawMenu: IMenuService[] = [];

    const isSupport = !isEmpty(note) && note.includes("isSupporter=true");

    const selectedSidebar = isSupport ? dummySidebarSupport : dummySidebar;

    switch (language) {
      case "vi":
        rawMenu = selectedSidebar?.vi as Array<IMenuService>;
        break;
      case "en":
        rawMenu = selectedSidebar?.eng as Array<IMenuService>;
        break;
      default:
        rawMenu = selectedSidebar?.vi as Array<IMenuService>;
    }

    if (!role) {
      rawMenu = this.removeStoreManagement(rawMenu);
    }

    menuConfig = this.mapMenuItems(rawMenu);

    return Promise.resolve(
      new BaseApiResponseModel<SidebarMenuConfigModel>(
        undefined,
        new SidebarMenuConfigModel(menuConfig),
        undefined,
        undefined
      )
    );
  }

  private removeStoreManagement = (
    items: IMenuService[] = []
  ): IMenuService[] =>
    items?.map((ele) => ({
      ...ele,
      subMenu: ele.subMenu?.filter(
        (child) => child?.componentName !== "StoreManagementFeature"
      ),
    }));

  private mapMenuItems(items: IMenuService[] = []): MenuConfigModel[] {
    return items
      .filter((item) => item.enable !== false)
      .map(
        (item) =>
          new MenuConfigModel(
            item.name,
            item.path,
            item.componentName,
            item.icon,
            this.mapMenuItems(item.subMenu)
          )
      );
  }
}

export default new SidebarMenuConfigRepository();
